import { ButtonVariant } from '@design-system';
import { OrderSide } from '@shared-types';

export enum OrderFormType {
	DEPOSIT = 1,
	OPTION = 3
}

export type OrderValidRangesType = { volume: { min: number; max: number }; price: { min: number; max: number } };

/**
 * Account figures the order form calculates against. Sourced per symbol from the
 * customer's deposit holding; figures the kala API exposes no endpoint for yet stay 0.
 */
export interface OrderFormAccountContext {
	/** تعداد دارایی — remaining quantity held of this symbol. */
	currentAsset: number;
	/** میانگین خرید کاربر روی نماد */
	averageBuyPrice: number;
	/** قدرت خرید */
	buyingPower: number;
	/**
	 * The symbol's per-side commission rates from the market snapshot (`buyCommission` /
	 * `sellCommission`), as fractions — already split out of its round-trip `commission`.
	 */
	buyCommissionRate: number;
	sellCommissionRate: number;
}

export interface OrderFormData {
	isin: string;
	side: OrderSide;
	quantity: number | null;
	price: number | null;
}

export type OrderFormInputData = Partial<OrderFormData> & {
	isEdit?: boolean;
	isCopy?: boolean;
	orderId?: number;
	validRanges?: OrderValidRangesType;
	formType?: OrderFormType;
	/** Best bid of the live depth ladder — used for price lock sync */
	bestBuyLimitPrice?: number;
	/** Best ask of the live depth ladder — used for price lock sync */
	bestSellLimitPrice?: number;
};

export type IOrderActionButtonType = 'SUBMIT' | 'CLOSE' | 'CANCEL' | 'EDIT';

export interface IOrderActionButton {
	id: string;
	action: IOrderActionButtonType;
	label: string;
	class: string;
	cyTag?: string;
	disabled?: boolean;
	loading?: boolean;
	variant: ButtonVariant;
	confirmBeforeAction: boolean;
}

export interface IOrderFormSideActions {
	actions: Partial<Record<IOrderActionButtonType, IOrderActionButton>>;
}

export interface IOrderFormConfig {
	type: OrderFormType;
	sideInfo: Record<OrderSide.Buy | OrderSide.Sell, IOrderFormSideActions>;
}
